import { configureStore } from '@reduxjs/toolkit';

import rootReducer from "./reducers";
import setAuthToken from "./utils/api/token";
import setInstance from "./utils/api/instance";



const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
});

// Set up a store subscription listener
// to store the user's token and instance in localStorage

// Initialize current state from redux store for subscription comparison
let currentState = store.getState();

store.subscribe(() => {
  const previousState = currentState;
  currentState = store.getState();

  const token = currentState.auth?.token;
  const instance = currentState.auth?.instance;

  // Only update token and instance if they have changed
  if (previousState.auth?.token !== token) {
    if (token) setAuthToken(token);
    else setAuthToken(null);  // Clear token when not present
  }

  if (previousState.auth?.instance !== instance) {
    if (instance) setInstance(instance);
    else setInstance(null);  // Clear instance when not present
  }
});

export default store;